
export default {
    data: () => ({}),
    methods: {
        async getReceiptById(id) {
            return this.$communicator.then(
                this,
                await this.$communicator("receipt_by_id", {
                    arguments: [id]
                })
            );
        },
        async refundReceipt(data) {
            return (this.$communicator.then(
                this,
                await this.$communicator("create_receipt", {
                    params: data
                })
            ),
                this.$toast.success("Success", {timeout: 2000}))
        }
    }
}
